import React from "react";
import moment from "moment";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  TextField,
  TimeField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// One appointment slot of a garage.
export default class AppointmentForm extends React.Component {
  constructor(props) {
    super(props);
    const item = props.item || {};
    const [start, end] = item.fromToHours
      ? `${item.fromToHours}`.split("-")
      : [null, null];

    this.state = {
      id: item.id || "",
      version: item.version,
      date: item.date ? moment(item.date).format("YYYY-MM-DD") : "",
      startHours: start ? moment(start.trim(), "HH:mm") : null,
      endHours: end ? moment(end.trim(), "HH:mm") : null,
      appointmentThreshold:
        item.appointmentThreshold === undefined ? "" : item.appointmentThreshold,
      loading: false,
      error: "",
      errors: {},
    };
    this.engine = new RequestEngine();
  }

  validate() {
    const { date, startHours, endHours, appointmentThreshold } = this.state;
    const errors = {};

    if (!date) {
      errors.date = strings.required_hint;
    }
    if (!startHours || !endHours) {
      errors.hours = strings.hours_required_hint;
    }
    if (`${appointmentThreshold}`.trim() === "" || Number(appointmentThreshold) < 4) {
      errors.appointmentThreshold = strings.threshold_min_hint;
    }
    return errors;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { id, version, date, startHours, endHours, appointmentThreshold } =
      this.state;

    this.setState({ loading: true, error: "", errors: {} });

    const payload = {
      date,
      fromToHours: `${moment(startHours).format("HH:mm")}-${moment(
        endHours
      ).format("HH:mm")}`,
      appointmentThreshold: Number(appointmentThreshold),
    };

    const pathname = `merchants-branches/${this.props.branchId}/appointments`;

    try {
      const response = id
        ? await this.engine.updateItem(pathname, id, { ...payload, version })
        : await this.engine.saveItem(pathname, {
            ...payload,
            customerBooksIds: [],
          });

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const {
      date,
      startHours,
      endHours,
      appointmentThreshold,
      loading,
      error,
      errors,
    } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection title={strings.appointment} icon="nc-icon nc-calendar-60">
          <FormGrid>
            <TextField
              label={strings.date}
              type="date"
              required
              value={date}
              onChange={(value) => this.setState({ date: value })}
              error={errors.date}
            />
            <TextField
              label={strings.appointmentThreshold}
              type="number"
              min="4"
              required
              value={appointmentThreshold}
              onChange={(value) =>
                this.setState({ appointmentThreshold: value })
              }
              error={errors.appointmentThreshold}
              help={strings.threshold_min_hint}
            />
          </FormGrid>
          <FormGrid>
            <TimeField
              label={strings.starttime}
              required
              value={startHours}
              onChange={(value) => this.setState({ startHours: value })}
              error={errors.hours}
            />
            <TimeField
              label={strings.endtime}
              required
              value={endHours}
              onChange={(value) => this.setState({ endHours: value })}
            />
          </FormGrid>
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
